export default __webpack_public_path__ + "static/media/Pear@3x.cba66b5f.png";